// extracted by mini-css-extract-plugin
export default {"reviews_section":"ReviewsPage_reviews_section__u+Mw3"};